// extracted by mini-css-extract-plugin
export default {"button":"Bl-z","reviewSort":"Cl-z"};